import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import type { ComponentProps } from "react";
import { createElement } from "react";
import { z } from "zod";

import { defineHead } from "../-common";

import { usePageSearchSetters } from "./-common";

import { InquiriesPage } from "~/pages/admin-panel";
import { Tk } from "~/shared/i18n";
import { zPageSearch } from "~/widgets/admin-panel/model/page-search";

const zInquiriesPageActionType = z.enum(["EDIT", "DELETE", "RESOLVE"]);

function Component() {
  const navigate = useNavigate({
    from: Route.fullPath,
  });
  const { filter, currentAction } = Route.useSearch();

  return createElement(InquiriesPage, {
    search: {
      filter,
      currentAction,
      ...usePageSearchSetters(navigate, filter, currentAction),
    },
  } satisfies ComponentProps<typeof InquiriesPage>);
}

export const Route = createFileRoute("/{-$locale}/admin-panel/inquiries")({
  head: defineHead({
    titleT: {
      key: Tk.INQUIRY,
      options: {
        count: 1,
      },
    },
  }),
  component: Component,
  validateSearch: zodValidator(zPageSearch(zInquiriesPageActionType)),
});
